import { Routes } from '@angular/router';
import {
  ApplicantDataSectionComponent,
  ApplicantDataComponentConfig
} from '../common/applicant-data-section/applicant-data-section.component';
import {
  ApplicationDataSectionComponent,
  ApplicationDataComponentConfig
} from '../common/application-data-section/application-data-section.component';
import {
  AgreementsDataSectionComponent,
  AgreementsDataComponentConfig
} from '../common/agreements-data-section/agreements-data-section.component';
import {
  ContractorDataComponentConfig,
  ContractorDataSectionComponent
} from '../common/contractor-data-section/contractor-data-section.component';
import {
  OccupationDataComponentConfig,
  OccupationDataSectionComponent
} from '../common/occupation-data-section/occupation-data-section.component';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';
import {
  PaymentsDataComponentConfig,
  PaymentsDataSectionComponent
} from '../common/payments-data-section/payments-data-section.component';

export const stages = [
  'Wnioskodawca',
  'Dane wniosku',
  'Inwestor',
  'Wykonawca',
  'Zajęcia',
  'Prognozowane opłaty',
  'Zgody',
  'Załączniki'
];

export const applicantDataSectionConfig: ApplicantDataComponentConfig = {
  stages
};

export const applicationDataSectionConfig: ApplicationDataComponentConfig = {
  stages,
  applicationSubjectControlType: 'text',
  addManagerControls: true,
  cancelUrl: '../wnioskodawca',
  successUrl: '../inwestor'
};

export const investorDataSectionConfig: ContractorDataComponentConfig = {
  stages,
  cancelUrl: '../dane-wniosku',
  successUrl: '../wykonawca',
  customTitles: {
    sectionTitle: 'Inwestor',
    tag: 'investor',
    dataSameAsApplicantLabels: {
      rejectLabel: 'Chcę wprowadzić dane inwestora',
      acceptLabel: 'Dane inwestora są takie same jak dane wnioskodawcy'
    },
    cardTitle: 'Dodanie inwestora',
    addBtnTitle: 'Dodaj inwestora',
    addBtn2Title: 'Dodaj kolejnego inwestora',
    noDataInfo: 'Brak dodanych inwestorów!'
  }
};

export const performerDataSectionConfig: ContractorDataComponentConfig = {
  stages,
  cancelUrl: '../inwestor',
  successUrl: '../dane-zajecia',
  customTitles: {
    sectionTitle: 'Wykonawca',
    tag: 'performer',
    dataSameAsApplicantLabels: {
      rejectLabel: 'Chcę wprowadzić dane wykonawcy',
      acceptLabel: 'Dane wykonawcy są takie same jak dane wnioskodawcy'
    },
    cardTitle: 'Dodanie wykonawcy',
    addBtnTitle: 'Dodaj wykonawcę',
    addBtn2Title: 'Dodaj kolejnego wykonawcę',
    noDataInfo: 'Brak dodanych wykonawców!'
  }
};

export const occupationDataSectionConfig: OccupationDataComponentConfig = {
  stages,
  cancelUrl: '../wykonawca',
  successUrl: '../oplaty',
  hideCityControl: true,
  hideOccupationTypeControl: true,
  hidePurposeControl: true,
  addTypeOfFailureControl: true
};

export const paymentsDataSectionConfig: PaymentsDataComponentConfig = {
  stages,
  successUrl: '../zgody',
  cancelUrl: '../dane-zajecia'
};

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  successUrl: '../zalaczniki',
  cancelUrl: '../oplaty'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const notificationOfEmergencyOccupationRoutes: Routes = [
  {
    component: ApplicantDataSectionComponent,
    path: 'wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicantDataSectionComponent,
    path: ':appId/wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicationDataSectionComponent,
    path: ':appId/dane-wniosku',
    data: applicationDataSectionConfig
  },
  {
    component: ContractorDataSectionComponent,
    path: ':appId/inwestor',
    data: investorDataSectionConfig
  },
  {
    component: ContractorDataSectionComponent,
    path: ':appId/wykonawca',
    data: performerDataSectionConfig
  },
  {
    component: OccupationDataSectionComponent,
    path: ':appId/dane-zajecia',
    data: occupationDataSectionConfig
  },
  {
    component: PaymentsDataSectionComponent,
    path: ':appId/oplaty',
    data: paymentsDataSectionConfig
  },
  {
    component: AgreementsDataSectionComponent,
    path: ':appId/zgody',
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  { path: '', redirectTo: 'wnioskodawca', pathMatch: 'prefix' }
];
